import React from 'react';

const MatrixCanva = () => {
    React.useEffect(() => {
        const canvas = document.getElementById("mat-lienzo");
        const ctx = canvas.getContext("2d");

        let cols, position_y;

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            cols = Math.floor(canvas.width / 20) + 1;
            position_y = Array(cols).fill(0);
        };

        const matrix = () => {
            ctx.fillStyle = '#0001';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.fillStyle = '#C57EEE';
            ctx.font = '15pt monospace';

            position_y.forEach((y, ind) => {
                const text = String.fromCharCode(Math.random() * 128);
                const x = ind * 20;
                ctx.fillText(text, x, y);

                if (y > canvas.height + Math.random() * 10000) {
                    position_y[ind] = 0;
                } else {
                    position_y[ind] = y + 20;
                }
            });
        };

        resize();
        window.addEventListener('resize', resize);

        const interval = setInterval(matrix, 50);

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return (
        <canvas className="frontlogo-canvas" id="mat-lienzo"></canvas>
    );
};

export default MatrixCanva;
